const t = "_root_y8y1p_1", o = "_header_y8y1p_10", e = "_content_y8y1p_17", _ = "_footer_y8y1p_23", c = "_space_y8y1p_30", n = "_vertical_y8y1p_34", r = {
  root: t,
  header: o,
  content: e,
  footer: _,
  space: c,
  vertical: n
};
export {
  e as content,
  r as default,
  _ as footer,
  o as header,
  t as root,
  c as space,
  n as vertical
};
//# sourceMappingURL=index.es5511.js.map
